import type { AxiosResponse } from "axios"

import { axiosClient } from "$/http"

import { ECoachingChatMutationUrl as EMutationUrl } from "../../config"

import type {
    TCoachingChatCreateConversationMutationOptions as TConversationOptions,
    TCoachingChatCreateConversationMutationResponse as TConversationResponse,
    TCoachingChatCreateMatrixFeedbackMutationParams as TMatrixFeedbackMutationParams,
    TCoachingChatCreateMessageMutationParams as TMessageParams,
    TCoachingChatCreateMessageMutationResponse as TMessageResponse,
    TCoachingChatSeedMutationOptions as TSeedAnswerOptions,
    TCoachingChatSeedMutationParams as TSeedAnswerParams,
    TCoachingChatSeedMutationResponse as TSeedAnswerResponse,
    TCoachingChatCreateSocketTokenMutationResponse as TSocketMutationResponse
} from "./coaching-chat.api.mutations.hooks"

async function seedAnswer({
    question_uuid,
    answer,
    chapterComponentId: component,
    chapterId: chapter_progress
}: Partial<TSeedAnswerParams> &
    Pick<TSeedAnswerOptions, "chapterComponentId" | "chapterId">): Promise<TSeedAnswerResponse> {
    return axiosClient.post(EMutationUrl.HandleSeed(), { question_uuid, answer, component, chapter_progress })
}

async function conversation({
    chapterId: chapter_progress,
    chapterComponentId: component
}: Pick<TConversationOptions, "chapterComponentId" | "chapterId">): Promise<TConversationResponse> {
    return axiosClient.post(EMutationUrl.CreateConversation(), { component, chapter_progress })
}

async function message({ message, conversationId }: TMessageParams): Promise<TMessageResponse> {
    return axiosClient.post(EMutationUrl.CreateMessage(Number(conversationId)), { message })
}

async function disclaimer(): Promise<AxiosResponse<void>> {
    return axiosClient.post(EMutationUrl.CreateDisclaimerAwareness(), {})
}

async function matrixFeedback({
    conversationId,
    ...rest
}: TMatrixFeedbackMutationParams): Promise<AxiosResponse<void>> {
    return axiosClient.post(EMutationUrl.CreateMatrixFeedback(conversationId), { ...rest })
}

async function socketToken(): Promise<TSocketMutationResponse> {
    return axiosClient.post(EMutationUrl.CreateSocketToken())
}

const mutators = {
    seedAnswer,
    conversation,
    message,
    disclaimer,
    matrixFeedback,
    socketToken
}

export { mutators as coachingChatMutationsMutators }
